/*  Slick carousel accessibility corrections  ·  Spark*l  ·  2026-08-25
 *
 *  🚨 SLICK LABELS A CAROUSEL AS A LISTBOX. It puts role="listbox" on .slick-track and
 *  role="option" on every slide. That is wrong: a listbox is a form control for CHOOSING a
 *  value, and its options may not contain links, buttons or other focusable things. Our
 *  slides contain exactly that, so the markup is contradictory and axe reports it three
 *  ways at once:
 *
 *      aria-input-field-name   the "listbox" has no accessible name
 *      nested-interactive      an "option" contains focusable children
 *      aria-hidden-focus       an aria-hidden slide still contains tabbable elements
 *
 *  🚨 THE FIX IS TO REMOVE THE ROLES, NOT TO NAME THEM. Naming the listbox would silence
 *  the warning while leaving a screen reader told it is operating a form control when it is
 *  looking at a slideshow. Stripped of the roles, the slides are read as ordinary content,
 *  which is what they are.
 *
 *  ⚠️ Slick re-applies these attributes on every slide change, so this cannot run once. It
 *  binds to slick's own lifecycle events and re-runs each time.
 *
 *  ⚠️ Doing it here rather than in the 33 separate .slick() calls in theme.js: one place to
 *  read, one place to change, and it survives the next theme update.
 */
(function () {
  if (typeof window.jQuery === 'undefined') return;
  var $ = window.jQuery;

  function correct(root) {
    var $root = root ? $(root) : $(document);

    // a carousel is not a listbox and its slides are not options
    $root.find('.slick-track[role="listbox"]').removeAttr('role');
    $root.find('.slick-slide[role="option"]').removeAttr('role');

    // a hidden slide must not hold anything the keyboard can still land on
    $root.find('.slick-slide[aria-hidden="true"]').each(function () {
      $(this).find('a, button, input, select, textarea, iframe, [tabindex]')
             .attr('tabindex', '-1');
    });

    // ...and the visible one must get its stops back
    $root.find('.slick-slide[aria-hidden="false"], .slick-slide.slick-active').each(function () {
      $(this).find('a, button, input, select, textarea, iframe').removeAttr('tabindex');
    });
  }

  $(document)
    .on('init reInit afterChange setPosition breakpoint', '.slick-slider', function () {
      correct(this);
    });

  $(function () {
    correct();
    // slick may finish initialising after DOM ready on lazy-loaded sections
    setTimeout(correct, 400);
    setTimeout(correct, 1500);
  });
})();
